import React from "react";

const Bash_Curl = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Curl</h2>
      <p>Transfer data from or to a server using various protocols.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>curl [options] URL</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>curl https://example.com
curl -I https://example.com</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -o to save output to a file, -I to fetch headers.</p>
    </div>
  );
};

export default Bash_Curl;
